// hooks/schedule/useDeleteTimeRange.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ScheduleClient } from "../../web-api-client";
import { makeFetchWithAuth } from "../../auth/authFetch";
import { fetchWithTimeout } from "../../utils/fetchWithTimeout";
import { appConfig } from "../../appconfig";

export type DeleteTimeRangePayload = {
  clinicId: number;
  localDate: string; // dd/MM/yyyy
  startTime: string; // HH:mm
  endTime: string;   // HH:mm
};

export function useDeleteTimeRange() {
  const qc = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (payload: DeleteTimeRangePayload) => {
      const client = new ScheduleClient(appConfig.apiBaseUrl, {
        fetch: makeFetchWithAuth(fetchWithTimeout(), {
          onUnauthorized: () =>
            navigate("/login", {
              replace: true,
              state: { from: window.location.pathname },
            }),
        }),
      });

      await client.deleteTimeRangeSlot(payload as any);
      return payload;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["schedules"] });
    },
  });
}